import {PANELMANAGER_SET_PANEL_ICON} from '../../constants';

export type SetPanelIconAction = {
    type : typeof PANELMANAGER_SET_PANEL_ICON;
    panelKey : string;
    icon : string;
}

/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {string} icon
 *
 * @return {SetPanelIconAction}
 */
const setPanelIcon = ( panelKey : string, icon : string ) : SetPanelIconAction => {
    return {
        type: PANELMANAGER_SET_PANEL_ICON,
        panelKey,
        icon
    };
}
export type SetPanelIcon = typeof setPanelIcon;

export default setPanelIcon;
